import StarIcon from "@/assets/svg/Stars.svg";

const AIPill = ({ text = "" }) => {
  return (
    <button className="self-end py-0.5 px-2 rounded-2xl bg-warning-50 flex gap-1.5 items-center hover:shadow-warning-100 hover:shadow-md hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all duration-200 ease-in-out">
      <img
        src={StarIcon}
        alt="stars-icon"
        className="object-contain"
        width={13}
        height={15}
      />
      <span className="text-[10.5px] font-medium text-orange-400">{text}</span>
    </button>
  );
};

export default AIPill;
